import { Venafi } from '../models/Venafi';

export class VenafiMapper {
  mapGQLModel(data: any): Venafi {
    return new Venafi(data.url, data.accessToken, data.trustedCaCertificate);
  }
}
